var React = require('react');

function MinusIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#C4C4C4","key":0}),React.createElement("path",{"d":"M9 16H24","stroke":"white","strokeWidth":"3","strokeLinecap":"round","key":1})]);
}

MinusIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MinusIcon;

MinusIcon.default = MinusIcon;
